import React from "react";
import { useNavigate } from "react-router-dom";
import { User, Users } from "lucide-react";
import { useScope } from "../context/ScopeContext";

/**
 * Mobile-first scope toggle. Renders two pills: Personal / Pareja.
 * When the user has no household, tapping "Pareja" routes to /configuracion#pareja.
 */
export default function ScopeToggle({ className = "" }) {
  const navigate = useNavigate();
  const { scope, setScope, hasHousehold, partner } = useScope();

  const handleShared = () => {
    if (!hasHousehold) {
      navigate("/configuracion#pareja");
      return;
    }
    setScope("shared");
  };

  return (
    <div
      data-testid="scope-toggle"
      className={`inline-flex items-center gap-1 bg-white border border-line rounded-full p-1 ${className}`}
    >
      <button
        type="button"
        data-testid="scope-personal"
        onClick={() => setScope("personal")}
        className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-bold transition-colors ${
          scope === "personal" ? "bg-sage-900 text-bone" : "text-soft hover:text-ink"
        }`}
      >
        <User size={13} /> Personal
      </button>
      <button
        type="button"
        data-testid="scope-shared"
        onClick={handleShared}
        className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-bold transition-colors ${
          scope === "shared"
            ? "bg-sage-900 text-bone"
            : hasHousehold ? "text-soft hover:text-ink" : "text-soft/60"
        }`}
        aria-label={hasHousehold ? "Cambiar a modo pareja" : "Invitar a tu pareja"}
      >
        <Users size={13} />
        {hasHousehold && partner ? `Pareja · ${partner.name || "Pareja"}` : "Pareja"}
      </button>
    </div>
  );
}
